module.exports = __webpack_public_path__ + "static/imgAbout1-e744a3b77d2b905062050a8f18f6f7d2.svg";